import React from 'react';
import { SvgPropType } from '../SvgPropType';
import { useThemedStyletron } from '../../../theme';

export const JobConcessionsIcon = ({
  width = 36,
  height = 36,
  color,
}: SvgPropType) => {
  const [, theme] = useThemedStyletron();
  const svgColor = color ?? theme.colors.primary600;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4302_23841)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.57098 6.43017L14.9872 0.95759C14.9476 0.961527 14.9085 0.970588 14.8707 0.984773L0.299252 6.45614C0.119235 6.52373 0 6.69587 0 6.88816V8.33468C0 8.44514 0.0895427 8.53468 0.2 8.53468H7.18351C7.29397 8.53468 7.38351 8.44514 7.38351 8.33468V6.80149C7.38351 6.65497 7.45309 6.51716 7.57098 6.43017ZM11.674 6.45816L15.0136 0.955727C15.0264 0.955187 15.0393 0.955187 15.0522 0.955728L18.3918 6.45816C18.4356 6.53034 18.4588 6.61315 18.4588 6.69759V8.33468C18.4588 8.44514 18.3692 8.53468 18.2588 8.53468H15.9555V18.7272C15.9555 18.9823 15.7487 19.1889 15.4937 19.1887C15.239 19.1885 15.0326 18.9819 15.0326 18.7272L15.0327 8.53468H11.807C11.6966 8.53468 11.607 8.44514 11.607 8.33468V6.69759C11.607 6.61315 11.6302 6.53034 11.674 6.45816ZM22.4948 6.43017L15.0786 0.957591C15.1182 0.961529 15.1573 0.970589 15.1951 0.984773L29.7665 6.45614C29.9465 6.52373 30.0658 6.69587 30.0658 6.88816V8.33468C30.0658 8.44514 29.9762 8.53468 29.8658 8.53468H22.8823C22.7718 8.53468 22.6823 8.44514 22.6823 8.33468V6.80149C22.6823 6.65497 22.6127 6.51716 22.4948 6.43017ZM25.0873 18.1225C25.1515 17.5636 25.419 17.0479 25.8389 16.6735C26.2589 16.2992 26.8018 16.0924 27.3644 16.0925H34.8539C35.1579 16.0925 35.4495 16.2133 35.6644 16.4283C35.8794 16.6433 36.0002 16.9348 36.0002 17.2389C36.0002 17.5429 35.8794 17.8345 35.6644 18.0494C35.4495 18.2644 35.1579 18.3852 34.8539 18.3852H28.3841C28.1032 18.385 27.8319 18.4881 27.6219 18.6747C27.4119 18.8614 27.2778 19.1187 27.245 19.3978L27.0413 20.1582H27.6797C28.4137 20.1582 29.0087 20.7532 29.0087 21.4872V29.1105C29.0087 29.8445 28.4137 30.4395 27.6797 30.4395H27.3722C26.6522 27.8283 24.26 25.9106 21.4199 25.9106C18.5798 25.9106 16.1877 27.8283 15.4677 30.4395H5.0815C4.34749 30.4395 3.75246 29.8445 3.75246 29.1105V21.4872C3.75246 20.7532 4.34749 20.1582 5.0815 20.1582H24.5706L25.0873 18.1225ZM7.164 35.7655C5.82859 35.7655 4.74603 34.6829 4.74603 33.3475C4.74603 32.0121 5.82859 30.9295 7.164 30.9295C8.49942 30.9295 9.58198 32.0121 9.58198 33.3475C9.58198 34.6829 8.49942 35.7655 7.164 35.7655ZM19.2462 31.5918C19.2462 32.7923 20.2194 33.7655 21.4199 33.7655C22.6205 33.7655 23.5937 32.7923 23.5937 31.5918C23.5937 30.3912 22.6205 29.418 21.4199 29.418C20.2194 29.418 19.2462 30.3912 19.2462 31.5918ZM21.4199 35.7655C19.1148 35.7655 17.2462 33.8969 17.2462 31.5918C17.2462 29.2867 19.1148 27.418 21.4199 27.418C23.725 27.418 25.5937 29.2867 25.5937 31.5918C25.5937 33.8969 23.725 35.7655 21.4199 35.7655Z"
          fill={svgColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_4302_23841">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(0 0.765625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
